import template from './vault.edit.html';
import controller from './vault.edit.controller';
import './vault.edit.scss';

let vaulteditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default vaulteditComponent;


// WEBPACK FOOTER //
// ./client/app/components/vault/edit/vault.edit.component.js